import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmptyShoppingCart = () => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingInlineStart: "400",
  paddingInlineEnd: "400",
  paddingBlockStart: "1500",
  paddingBlockEnd: "1500",
  children: [/*#__PURE__*/_jsx(Illustration, {
    name: "store-disabled",
    width: "125px",
    marginBlockEnd: "400"
  }), /*#__PURE__*/_jsx(Text, {
    as: "small",
    textAlign: "center",
    color: "text-core-subtle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.shoppingCart.emptyCart"
    })
  })]
});
export default EmptyShoppingCart;